import { PatchPayload } from "../service"
import { ACTION_TYPES } from "./types"

export const Action = {
    patch: (id: string, payload: PatchPayload) => {
        return {
            type: ACTION_TYPES.PATCH,
            id: id,
            payload: payload
        }
    },
}


// WEBPACK FOOTER //
// ./src/state/inventory/data/actions/actions.ts